const RoutesApp = {
    Login: '/login/',
    Signup: '/signup/',
    ChangeOwnPassword: '/change_own_password/',
    RequestNewPassword: '/reset_clave/',
    ConfirmNewPassword: '/nuevaclave/:token',
    ConfirmEmail: '/verificarcorreo/:token',
    RecoverUserName: '/recuperar_usuario/',
    Home: '/',
    Profile: '/profile/',
    Viniedos: { all: '/viniedos/', single: '/viniedos/' },
    Declaraciones: {
        all: '/declaraciones/',
        cosechaProbable: '/declaraciones/cosecha_probable/',
        nuevaCosechaProbable: '/declaraciones/nueva_cosecha_probable/',
        cosechaEfectiva: '/declaraciones/cosecha_efectiva/',
        nuevaCosechaEfectiva: '/declaraciones/nueva_cosecha_efectiva/',
        transferenciaViniedo: '/declaraciones/transferencia_viniedo/',
        nuevaTransferenciaViniedo:
            '/declaraciones/nueva_transferencia_viniedo/',
        modificacionViniedo: '/declaraciones/modificacion_viniedo/',
        nuevaModificacionViniedo: '/declaraciones/nueva_modificacion_viniedo/',
        divUnifViniedo: '/declaraciones/div_unif_viniedo/',
        nuevaDivUnifViniedo: '/declaraciones/nueva_div_unif_viniedo/',
        cancelacionViniedo: '/declaraciones/cancelacion_viniedo/',
        nuevaCancelacionViniedo: '/declaraciones/nueva_cancelacion_viniedo/',
    },
    Guias: {
        all: '/guias/',
        single: '/guias/',
        new: '/guias/nueva/',
        bodega: '/guiabodega/',
        qr: '/guiaqr/',
    },
    Managers: {
        all: '/encargados/',
        single: '/encargado/',
    },
    Users: {
        all: '/usuarios/',
        single: '/usuario/',
        createINAVI: '/usuarioINAVI/',
    },
    Settings: '/ajustes/',
};

export default RoutesApp;
